/**
 * @fileoverview A function that provides the sites API.
 *
 * @example
 * const { result } = renderHook(() => useSitesAPI())
 */

import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from './utils/axiosBaseQuery'

export const sitesApi = createApi({
    reducerPath: 'sitesApi',
    baseQuery: axiosBaseQuery({ baseUrl: `/private/sites` }),
    endpoints: (builder) => ({
        getSites: builder.query<Novoic.API.Site[], void>({
            query: () => {
                const sp = new URLSearchParams(location.search)
                return {
                    url: location.search ? `?${sp.toString()}` : '',
                    method: 'GET',
                }
            },
        }),

        getSiteById: builder.query<Novoic.API.Site, string>({
            query: (siteId: string) => {
                return {
                    url: `/${siteId}`,
                    method: 'GET',
                }
            },
        }),

        getSitesCount: builder.query<{ count: number }, void>({
            query: () => {
                const sp = new URLSearchParams(location.search)
                return {
                    url: `/count?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),

        getSitesForStudyId: builder.query<Novoic.API.Site[], string>({
            query: (studyId: string) => {
                const sp = new URLSearchParams(location.search)
                sp.set('studies', studyId)
                return {
                    url: `?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),

        getSitesCountForStudyId: builder.query<{ count: number }, string>({
            query: (studyId: string) => {
                const sp = new URLSearchParams(location.search)
                sp.set('studies', studyId)
                return {
                    url: `/count?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),
    }),
})

export const {
    useGetSitesQuery,
    useGetSitesCountQuery,
    useGetSiteByIdQuery,
    useGetSitesForStudyIdQuery,
    useGetSitesCountForStudyIdQuery,
} = sitesApi
